/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketResponse } from '../../models/ticket-response';

export interface TicketControllerFindAll$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  ticket_numbers?: Array<number>;
  ticket_subnumber?: number;
  vendor_ticket_ref?: string;
  customer_ticket_ref?: string;
  opened_on_from?: string;
  opened_on_to?: string;
  intervention_date_from?: string;
  intervention_date_to?: string;
  sla_hours?: number;
  expired_sla?: boolean;
  ticket_status_ids?: Array<number>;
  schedule_status_ids?: Array<number>;
  tag_id?: number;
  related_agreement_ids?: Array<number>;
  service_ids?: Array<number>;
  registry_end_customer_name?: string;
  registry_end_customer_contact?: string;
  issue_description?: string;
  solution_description?: string;
  product_name?: string;
  product_brand?: string;
  product_serial_number?: string;
  assignment_date_from?: string;
  assignment_date_to?: string;
  assigned_user?: string;
  managed_by_user?: string;
  registry_end_customer_country_iso?: string;
  registry_end_customer_italy_region_ids?: Array<number>;
  registry_end_customer_italy_province_ids?: Array<number>;
  registry_end_customer_italy_city_ids?: Array<number>;
  registry_end_customer_address?: string;
  ticket_type_id?: number;
  billing_ticket?: boolean;
  billing_price?: number;
  active?: boolean;
  maintenance_registry_id?: number;
  ticket_tag_ids?: Array<number>;
  order_by?: string;
  order_direction?: string;
  return_ldv?: string;
}

export function ticketControllerFindAll(http: HttpClient, rootUrl: string, params: TicketControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('ticket_numbers', params.ticket_numbers, {});
    rb.query('ticket_subnumber', params.ticket_subnumber, {});
    rb.query('vendor_ticket_ref', params.vendor_ticket_ref, {});
    rb.query('customer_ticket_ref', params.customer_ticket_ref, {});
    rb.query('opened_on_from', params.opened_on_from, {});
    rb.query('opened_on_to', params.opened_on_to, {});
    rb.query('intervention_date_from', params.intervention_date_from, {});
    rb.query('intervention_date_to', params.intervention_date_to, {});
    rb.query('sla_hours', params.sla_hours, {});
    rb.query('expired_sla', params.expired_sla, {});
    rb.query('ticket_status_ids', params.ticket_status_ids, {});
    rb.query('schedule_status_ids', params.schedule_status_ids, {});
    rb.query('tag_id', params.tag_id, {});
    rb.query('related_agreement_ids', params.related_agreement_ids, {});
    rb.query('service_ids', params.service_ids, {});
    rb.query('registry_end_customer_name', params.registry_end_customer_name, {});
    rb.query('registry_end_customer_contact', params.registry_end_customer_contact, {});
    rb.query('issue_description', params.issue_description, {});
    rb.query('solution_description', params.solution_description, {});
    rb.query('product_name', params.product_name, {});
    rb.query('product_brand', params.product_brand, {});
    rb.query('product_serial_number', params.product_serial_number, {});
    rb.query('assignment_date_from', params.assignment_date_from, {});
    rb.query('assignment_date_to', params.assignment_date_to, {});
    rb.query('assigned_user', params.assigned_user, {});
    rb.query('managed_by_user', params.managed_by_user, {});
    rb.query('registry_end_customer_country_iso', params.registry_end_customer_country_iso, {});
    rb.query('registry_end_customer_italy_region_ids', params.registry_end_customer_italy_region_ids, {});
    rb.query('registry_end_customer_italy_province_ids', params.registry_end_customer_italy_province_ids, {});
    rb.query('registry_end_customer_italy_city_ids', params.registry_end_customer_italy_city_ids, {});
    rb.query('registry_end_customer_address', params.registry_end_customer_address, {});
    rb.query('ticket_type_id', params.ticket_type_id, {});
    rb.query('billing_ticket', params.billing_ticket, {});
    rb.query('billing_price', params.billing_price, {});
    rb.query('active', params.active, {});
    rb.query('maintenance_registry_id', params.maintenance_registry_id, {});
    rb.query('ticket_tag_ids', params.ticket_tag_ids, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
    rb.query('return_ldv', params.return_ldv, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketResponse;
      }>;
    })
  );
}

ticketControllerFindAll.PATH = '/ticket';
